import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickProbeColumns from '@/components/brick_probe_columns.vue'
import SummaryResult from '@/components/summary_result.vue'
import Vue from 'vue'

Vue.component('SummaryResult', SummaryResult)

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-rectangle-portrait', 'text-blue']
infos.front_classes = ['fas', 'fa-thermometer-half', 'text-white']
// infos.front_classes = ['fas', 'fa-temperature-low', 'text-white']
// infos.front_classes = []
infos.name = 'probecolumns'
infos.associated_class_name = 'AutomlProbeColumns'
infos.editing_component_name = 'BricProbeColumns'
infos.editing_component = BrickProbeColumns
infos.summary_component_name = 'SummaryResult'
infos.summary_component = SummaryResult
infos.descriptions = {
	en: {
		short_tooltip_description: 'Columns probe',
		full_tooltip_description: 'Probes columns',
		navbar_name: 'Column probe',
	},
	fr: {
		short_tooltip_description: 'Sonde de colonnes',
		full_tooltip_description: 'Sonde de colonnes',
		navbar_name: 'Sonde de colonne',
	},
}

infos.background_color = 'blue'

brick_registerer(infos)
